export default __webpack_public_path__ + "static/media/009-camel.19d2125b.svg";